"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Map_1 = __importDefault(require("ol/Map"));
var Vector_1 = __importDefault(require("ol/layer/Vector"));
var Vector_2 = __importDefault(require("ol/source/Vector"));
var Point_1 = __importDefault(require("ol/geom/Point"));
var LineString_1 = __importDefault(require("ol/geom/LineString"));
var Polygon_1 = __importDefault(require("ol/geom/Polygon"));
var GeoJSON_1 = __importDefault(require("ol/format/GeoJSON"));
var Feature_1 = __importDefault(require("ol/Feature"));
var View_1 = __importDefault(require("ol/View"));
var Tile_1 = __importDefault(require("ol/layer/Tile"));
var OSM_1 = __importDefault(require("ol/source/OSM"));
require("./Preview.css");
var antd_1 = require("antd");
require("ol/ol.css");
var geostyler_openlayers_parser_1 = __importDefault(require("geostyler-openlayers-parser"));
var _get = require('lodash/get');
var _isEqual = require('lodash/isEqual');
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var SymbolizerEditorWindow_1 = __importDefault(require("../SymbolizerEditorWindow/SymbolizerEditorWindow"));
var en_US_1 = __importDefault(require("../../../locale/en_US"));
/**
 * Symbolizer preview UI.
 */
var Preview = /** @class */ (function (_super) {
    __extends(Preview, _super);
    function Preview(props) {
        var _this = _super.call(this, props) || this;
        _this.getSampleGeomFromSymbolizer = function () {
            var kind = _get(_this.state, 'symbolizers[0].kind');
            switch (kind) {
                case 'Mark':
                case 'Icon':
                case 'Text':
                    return new Point_1.default([7.10066, 50.735851]);
                case 'Fill':
                    return new Polygon_1.default([[
                            [7.1031761169433585, 50.734268655851345],
                            [7.109270095825195, 50.734268655851345,],
                            [7.109270095825195, 50.73824770380063],
                            [7.1031761169433585, 50.73824770380063],
                            [7.1031761169433585, 50.734268655851345,]
                        ]]);
                case 'Line':
                    return new LineString_1.default([
                        [7.062578201293945, 50.721786104206004],
                        [7.077512741088867, 50.729610159968296],
                        [7.082319259643555, 50.732435192351126],
                        [7.097940444946289, 50.73748722929948],
                        [7.106866836547852, 50.73775882875318],
                        [7.117509841918945, 50.73889952925885],
                        [7.129182815551758, 50.7504679214779]
                    ]);
                default:
                    return new Point_1.default([7.10066, 50.735851]);
            }
        };
        /**
         *
         */
        _this.onEditButtonClicked = function () {
            _this.setState({
                editorVisible: !_this.state.editorVisible
            });
        };
        /**
         * Transforms the incoming symbolizers to an OpenLayers style object the
         * GeoStyler parser and applies it to the vector features on the map.
         *
         * @param {Symbolizer[]} symbolizers The symbolizers holding the style to apply
         */
        _this.applySymbolizersToMapFeatures = function (symbolizers) {
            var styleParser = new geostyler_openlayers_parser_1.default();
            // we have to wrap the symbolizer in a Style object since the writeStyle
            // only accepts a Style object
            var style = {
                name: 'WrapperStyle4Symbolizer',
                rules: [{
                        name: 'WrapperRule4Symbolizer',
                        symbolizers: symbolizers
                    }]
            };
            // parser style to OL style
            styleParser.writeStyle(style)
                .then(function (olStyles) {
                // apply new OL style to vector layer
                _this.dataLayer.setStyle(olStyles);
                return olStyles;
            });
        };
        var randomId = Math.floor((1 + Math.random()) * 0x10000);
        _this.state = {
            editorVisible: false,
            symbolizers: props.symbolizers,
            mapTargetId: "map_" + randomId,
            editorId: "gs-edit-preview-button_" + randomId
        };
        return _this;
    }
    Preview.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            symbolizers: nextProps.symbolizers
        };
    };
    Preview.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    Preview.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.dataLayer) {
            this.applySymbolizersToMapFeatures(this.state.symbolizers);
        }
        var features = this.props.internalDataDef ? this.props.internalDataDef.exampleFeatures : undefined;
        var prevFeatures = prevProps.internalDataDef ? prevProps.internalDataDef.exampleFeatures : undefined;
        var equal = true;
        if (!_isEqual(features, prevFeatures)) {
            equal = false;
        }
        this.state.symbolizers.some(function (symb, idx) {
            if (!prevState.symbolizers[idx] || !_isEqual(symb.kind, prevState.symbolizers[idx].kind)) {
                equal = false;
                return true;
            }
            else {
                return false;
            }
        });
        if (!equal) {
            this.updateFeatures();
        }
    };
    Preview.prototype.updateFeatures = function () {
        var projection = this.props.projection;
        // Remove previous features
        this.dataLayer.getSource().clear();
        var format = new GeoJSON_1.default({
            defaultDataProjection: this.props.dataProjection,
            featureProjection: this.map.getView().getProjection()
        });
        // add data features to style according to symbolizer and zoom to them (when existing)
        if (this.props.internalDataDef && this.props.internalDataDef.exampleFeatures) {
            var olFeatures = format.readFeatures(this.props.internalDataDef.exampleFeatures);
            this.dataLayer.getSource().addFeatures(olFeatures);
            // create a simple feature to see the symbolizer anyway
        }
        else {
            var geom = this.getSampleGeomFromSymbolizer();
            var sampleFeature = new Feature_1.default({
                geometry: geom.transform('EPSG:4326', projection),
                Name: 'Sample Feature'
            });
            this.dataLayer.getSource().addFeature(sampleFeature);
        }
        // zoom to feature extent
        var extent = this.dataLayer.getSource().getExtent();
        this.map.getView().fit(extent, {
            maxZoom: 20
        });
    };
    Preview.prototype.componentDidMount = function () {
        var _a = this.props, controls = _a.controls, interactions = _a.interactions, layers = _a.layers, onMapDidMount = _a.onMapDidMount, showOsmBackground = _a.showOsmBackground;
        var map;
        if (!this.props.map) {
            // create a new OL map and bind it to this preview DIV
            map = new Map_1.default({
                layers: [],
                controls: [],
                interactions: [],
                target: this.state.mapTargetId,
                view: new View_1.default({
                    projection: this.props.projection
                })
            });
        }
        else {
            // use passed in OL map and bind it to this preview DIV
            map = this.props.map;
            map.setTarget(this.state.mapTargetId);
        }
        // show an OSM background layer if configured and no map was passed in
        if (!this.props.map && showOsmBackground) {
            var osmLayer = new Tile_1.default({
                source: new OSM_1.default()
            });
            map.addLayer(osmLayer);
        }
        // add configured OL control to map, when no map was passed in
        if (!this.props.map && controls) {
            this.props.controls.forEach(function (ctrl) {
                map.addControl(ctrl);
            });
        }
        // add configured OL interaction to map, when no map was passed in
        if (!this.props.map && interactions) {
            this.props.interactions.forEach(function (iac) {
                map.addInteraction(iac);
            });
        }
        // add configured additional layers
        if (layers) {
            layers.forEach(function (layer) {
                map.addLayer(layer);
            });
        }
        var vectorLayer = new Vector_1.default({
            source: new Vector_2.default()
        });
        map.addLayer(vectorLayer);
        this.dataLayer = vectorLayer;
        this.map = map;
        this.updateFeatures();
        this.applySymbolizersToMapFeatures(this.state.symbolizers);
        if (onMapDidMount) {
            onMapDidMount(map);
        }
    };
    Preview.prototype.render = function () {
        var _a = this.props, mapHeight = _a.mapHeight, locale = _a.locale, symbolizers = _a.symbolizers, hideEditButton = _a.hideEditButton, onSymbolizersChange = _a.onSymbolizersChange, colorRamps = _a.colorRamps;
        var _b = this.state, editorVisible = _b.editorVisible, editorId = _b.editorId, mapTargetId = _b.mapTargetId;
        var windowX, windowY;
        if (editorVisible && !hideEditButton) {
            var buttonElement = document.getElementById(editorId);
            var buttonBounds = buttonElement.getBoundingClientRect();
            windowX = buttonBounds.right + window.scrollX;
            windowY = buttonBounds.top + window.scrollY;
        }
        return (React.createElement("div", { className: "gs-symbolizer-preview" },
            React.createElement("div", { id: mapTargetId, className: "map", style: { height: mapHeight } },
                !hideEditButton &&
                    React.createElement(antd_1.Button, { id: editorId, className: "gs-edit-preview-button", icon: "edit", onClick: this.onEditButtonClicked }, editorVisible ? locale.closeEditorText : locale.openEditorText),
                editorVisible && !hideEditButton ?
                    React.createElement(SymbolizerEditorWindow_1.default, { x: windowX, y: windowY, onClose: this.onEditButtonClicked, symbolizers: symbolizers, onSymbolizersChange: onSymbolizersChange, colorRamps: colorRamps }) : null)));
    };
    Preview.defaultProps = {
        locale: en_US_1.default.GsPreview,
        hideEditButton: false,
        projection: 'EPSG:3857',
        dataProjection: 'EPSG:4326',
        showOsmBackground: true,
        mapHeight: 267
    };
    Preview.componentName = 'Preview';
    return Preview;
}(React.Component));
exports.Preview = Preview;
exports.default = LocaleWrapper_1.localize(Preview, Preview.componentName);
//# sourceMappingURL=Preview.js.map